import { render, staticRenderFns } from "./approval_wait_approval.vue?vue&type=template&id=c88c4b9a"
import script from "./approval_wait_approval.vue?vue&type=script&lang=js"
export * from "./approval_wait_approval.vue?vue&type=script&lang=js"
import style0 from "./approval_wait_approval.vue?vue&type=style&index=0&id=c88c4b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports